import {
  HIDE_ICON_FOR_SHARED_NAVIGATION_BAR,
  DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR,
  SET_NAVIGATION_ACTIVE,
  HIDE_NAVIGATION,
  DISPLAY_NAVIGATION
} from './constants';

export const hideNavigationIcon = key => ({
  type: HIDE_ICON_FOR_SHARED_NAVIGATION_BAR,
  payload: key
});

export const displayNavigationIcon = (key, iconClassName, iconColorClassName) => ({
  type: DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR,
  payload: {key, iconClassName, iconColorClassName}
});

export const hideNavigation = () => ({
  type: HIDE_NAVIGATION
});

export const setNavigationActive = key => ({
  type: SET_NAVIGATION_ACTIVE,
  payload: key
});

export const displayNavigation = actions => ({
  type: DISPLAY_NAVIGATION,
  payload: actions
});



// WEBPACK FOOTER //
// ./src/features/shared/navigationBar/actionTypes.js